import styled from "styled-components"

import StatefulField from "shared/components/StatefulField"

export const FieldNumber = styled.div``

export const FieldLabel = styled(StatefulField.Input)`
  input {
    width: 7rem;
    text-overflow: ellipsis;
  }
`

export const FieldPricingEffect = styled(StatefulField.Select)`
  width: 10rem;
`

export const FieldPricingValueMoney = styled(StatefulField.MoneyInput)`
  width: 6rem;
`

export const FieldPricingValuePercentage = styled(StatefulField.Input)`
  width: 6rem;
`
